import api from "../utils/API";

const getAll = (params) => {
  return api.get(`/missions/list`, {params});
};

const getDetails = (uuid) => {
  return api.get(`/mission/${uuid}/details`);
};

const getDetailsForModification = (missionId) => {
  return api.get(`/mission/${missionId}/detailstomodify`);
};

const getMissionsOfSociete = (uuid, page, status) => {
  return api.get(`/societe/${uuid}/missions/list?page=${page}&limit=${50}&status=${status}`);
};
const addMission = (data) => {
  return api.post(`/mission/add`, data);
};

const editMission = (data, uuid) => {
  return api.put(`/mission/${uuid}/update`, data);
};

const getListDataEspaceMission = () => {
  return api.get(`/missions/espace/listdata/list`);
};
const getAllCandidatsOfMission = (mission) => {
  return api.get(`/processes/mission/${mission}/candidats/list`);
};
const updateStatusMission = (mission, activate = false) => {
  return api.put(`/mission/missions/${mission}/terminer`, { activate });
};
const getMissionsActive = (queryParams = "") => {
  return api.get(`/missions/active/list${queryParams}`);
}
const deleteMission = (uuid) => {
  return api.delete(`/mission/${uuid}/delete`);
}
// AI matching: best candidates of the vivier for a mission
const getAiCandidateProposals = (jobUuid, limit = 10, mode = "hybride") => {
  return api.post(`/mission/candidates`, { job_uuid: jobUuid, mode, limit });
}

export {getAll, getDetails, editMission, addMission, getMissionsOfSociete, getDetailsForModification, getListDataEspaceMission, updateStatusMission,getAllCandidatsOfMission, getMissionsActive, deleteMission, getAiCandidateProposals};
